import { gql } from '@apollo/client/core';
import PublicPortfolioIndexPageJobsInquiryFragment from './PublicPortfolioIndexPageJobsInquiry.fragment';

const PublicPortfolioIndexPageCurrentJobsInquiryQuery = gql`
  ${PublicPortfolioIndexPageJobsInquiryFragment}
  query PublicPortfolioIndexPageCurrentJobsInquiryQuery {
    currentJobsInquiry {
      ...PublicPortfolioIndexPageJobsInquiryFragment
    }
  }
`;

export default PublicPortfolioIndexPageCurrentJobsInquiryQuery;
